import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Initialize error tracking (must be before app renders)
import { initSentry } from './utils/sentry.js'
initSentry()

// Make admin utilities available in browser console
import './utils/restoreMattHabits.js'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
